import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { parse, stringify } from 'query-string';
import * as getFormData from 'get-form-data';

export interface FormProps extends Partial<RouteComponentProps> {
  method?: string;
  noValidate: boolean;
  className?: string;
  onSubmit: (event: any) => void;
  afterSubmit?: (event: any) => void;
  handleChange?: (event: any) => void;
  dispatchEvent?: (event: any) => void;
  replace?: boolean;
  acceptCharset?: string;
  action?: string;
  autoComplete?: string;
  encType?: string;
  name?: string;
  target?: string;
  wrappedComponentRef?: (ref: any) => void;
  wrappedFormRef?: object;
}

@withRouter
export class Form extends React.Component<FormProps> {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.wrappedFormRef = React.createRef();
  }

  private wrappedFormRef;

  get formElement() {
    return this.wrappedFormRef.current;
  }

  private handleChange(evt): void {
    const { handleChange } = this.props;

    if (typeof handleChange === 'function') {
      handleChange(evt);
    }
  }

  private handleSubmit(evt): void {
    const { onSubmit, afterSubmit, replace } = this.props;

    this.onSubmitOverride(evt, onSubmit, afterSubmit, replace);
  }

  private onSubmitOverride(event, onSubmit, afterSubmit, replace): void {
    const { history, location, action } = this.props;
    const formData = getFormData(event.target);

    this.ensureCorrectTypes(formData);

    if (onSubmit) {
      onSubmit(event, formData);
    }

    if (event.defaultPrevented) {
      return;
    }

    event.preventDefault();

    const queryString = stringify(formData);
    const queryParams = parse(location.search);
    const pwaOverlay = queryParams.pwaOverlay ? `&pwaOverlay=${queryParams.pwaOverlay}` : '';
    const submitUrl = `${action}?${queryString}${pwaOverlay}`;

    if (replace) {
      history.replace(submitUrl);
    } else {
      history.push(submitUrl);
    }

    if (afterSubmit) {
      afterSubmit({ action, formData, queryString, submitUrl });
    }
  }

  /*
    Fix known issue with get-form-data 1.2.5 library where hidden fields for element with multiple same-named inputs
    gets changed into an array. https://unpkg.com/browse/get-form-data@1.2.4/lib/index.js#L108
    Since we have all form elements defined as hidden type between the search-form and sort/filter form we run into this
    issue for radio button type elements.
  */
  private ensureCorrectTypes(formData) {
    const elementsToCorrect = [{ key: 'infantsInSeats' }];
    elementsToCorrect.forEach(({ key }) => {
      const elements = formData[key];
      if (Array.isArray(elements)) {
        formData[key] = formData[key][0];
      }
    });
  }

  public render() {
    const { acceptCharset, action, autoComplete, encType, method, name, noValidate, target, className } = this.props;

    const validFormData = { className, acceptCharset, action, autoComplete, encType, method, name, noValidate, target };

    return (
      <form {...validFormData} onChange={this.handleChange} onSubmit={this.handleSubmit} ref={this.wrappedFormRef}>
        {this.props.children}
      </form>
    );
  }
}
